import styled from 'styled-components';

import ThinCrossIcon from '#/assets/ThinCrossIcon';

import { cFFFFFF } from '#/colors';

import Modal from '#/components/common/modal';

import {
  useWithdrawModalActions,
  useWithdrawModalView,
} from '#/features/withdraw/modal-context';
import { WithdrawFormProvider } from '#/features/withdraw/form-context';
import {
  WithdrawProvider,
  useWithdrawView,
} from '#/features/withdraw/withdraw-context';

import WithdrawForm from './WithdrawForm';

export default function WithdrawModal() {
  const modalView = useWithdrawModalView();

  // Avoid rendering the provider if the modal is closed
  // so that state is not initialized unnecessarily and
  // is properly reset when the modal is opened again.
  if (!modalView.isOpen) return null;

  return (
    <WithdrawProvider>
      <WithdrawModalInternal />
    </WithdrawProvider>
  );
}

function WithdrawModalInternal() {
  const modalActions = useWithdrawModalActions();
  const withdrawView = useWithdrawView();

  const close = () => {
    modalActions.close();
  };

  const onDismiss = () => {
    if (withdrawView.isBusy) return;
    modalActions.close();
  };

  return (
    <Modal
      onDismiss={onDismiss}
      aria-labelledby="withdraw-modal-title"
      data-testid="withdraw-modal"
    >
      <Content>
        <Header>
          <Heading id="withdraw-modal-title">{withdrawView.step}</Heading>
          {!withdrawView.isBusy && <CloseButton onClick={close} />}
        </Header>
        <WithdrawFormProvider>
          <WithdrawForm />
        </WithdrawFormProvider>
      </Content>
    </Modal>
  );
}

const Content = styled.div`
  display: grid;
  gap: 16px;
`;

const Header = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
`;

const Heading = styled.h1`
  font-size: 14px;
  font-weight: 700;
  line-height: 19px;
  margin: 0;
`;

const CloseButton = styled.button.attrs({
  children: <ThinCrossIcon size={12} />,
  type: 'button',
  'aria-label': 'Close',
})`
  padding: 0;
  background: none;
  border: none;
  color: ${cFFFFFF};
`;
